import BulkMessageModalAbstract from './bulk-message-modal-abstract';

export default class ContactBulkMessageModalController extends BulkMessageModalAbstract {

    _getParametersForTemplatesStore() {
        return {
            ...super._getParametersForTemplatesStore(),
            onlyGlobal: true
        };
    }

    _getDisplayStoreFields() {
        return [
            'id',
            'full_name',
            'preferred_email',
            'company_name',
            'profile_image'
        ];
    }

    _getDisplayStoreSort() {
        return {
            'full_name': 'asc'
        };
    }

    _formatDisplayRow(row, index) {
        return {
            ...super._formatDisplayRow(row, index),
            name: row.full_name ? row.full_name : row.company_name,
            company: (_.isUndefined(row.company_name) ? '' : row.company_name) + '',
            image_url: row.profile_image.thumbnail,
            email: row.preferred_email
        };
    }

    _prepareRecipientPostData() {
        return {
            recipient_type: 'contact',
            contacts: this.recipientsStore.getters.selectedFilters
        }
    }

    _getPreviewUrl(recipient) {
        return `templates/${this.selectedTemplateId}/preview/contact/${recipient.id}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/bulk-send/contact-bulk-message-modal.js